import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-repower-downtime-status-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class RepowerDowntimeStatusTableComponent {
  @Input() data: any;

  get cutoffLabel(): string {
    return this.data?.cutoffLabel || '';
  }

  get columns(): Array<{ header: string; key: string }> {
    return this.data?.tableColumns || [];
  }

  get rows(): any[] {
    const sourceRows = Array.isArray(this.data?.statusRows) ? this.data.statusRows : [];

    const positiveSource =
      sourceRows.find((row: any) => String(row?.downtime || '').includes('<')) ||
      sourceRows.find((row: any) => String(row?.status || '').toLowerCase().includes('positive'));

    const negativeSource =
      sourceRows.find((row: any) => String(row?.downtime || '').includes('>')) ||
      sourceRows.find((row: any) => String(row?.status || '').toLowerCase().includes('negative'));

    return [
      {
        downtime: '<= 2%',
        status: positiveSource?.status || 'Positive/Acceptable',
        statusColor: positiveSource?.statusColor || '#4CAF50'
      },
      {
        downtime: '> 2%',
        status: negativeSource?.status || 'Negative/Action Required',
        statusColor: negativeSource?.statusColor || '#F44336'
      }
    ];
  }
}
